import generate from "./generate";
import paypoint from "./paypoint";
import upload from "./upload";


const repChild = [
    generate,
    upload,
    paypoint
];

export default repChild;